import { render, staticRenderFns } from "./month_calendar.vue?vue&type=template&id=64767a68&scoped=true&"
import script from "./month_calendar.vue?vue&type=script&lang=js&"
export * from "./month_calendar.vue?vue&type=script&lang=js&"
import style0 from "./month_calendar.vue?vue&type=style&index=0&id=64767a68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64767a68",
  null
  
)

export default component.exports